'use strict';

// The composite employer-tax rate used for every labor-cost ESTIMATE (P&L,
// staffing planner, payroll PDFs): FICA + FUTA + RI SUI + workers' comp.
// One place, shared by server and UI, so a rate change (RI SUI moves yearly)
// is one edit. The label strings used to hardcode "12.25%" in four files.

const EMPLOYER_TAX_PCT = 0.1225;
const EMPLOYER_TAX_LABEL = `${Number((EMPLOYER_TAX_PCT * 100).toFixed(2))}%`;   // "12.25%"

module.exports = { EMPLOYER_TAX_PCT, EMPLOYER_TAX_LABEL };
